import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m7.5 9.333 3.92 2.831a.995.995 0 0 0 1.16 0l3.92-2.83M5.92 19h12.16c1.612 0 2.92-1.273 2.92-2.844V7.844C21 6.274 19.692 5 18.08 5H5.92C4.309 5 3 6.273 3 7.844v8.312C3 17.726 4.308 19 5.92 19Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnMail;
